import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardHeader, CardBody, Row, Col, Table } from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";

const looksLikeDate = (value) =>
  typeof value === "string" && /^\d{4}-\d{2}-\d{2}(T|\s)/.test(value);

const formatCell = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (looksLikeDate(value)) {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    }
  }
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

const humanize = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const WalletHistory = () => {
  const { cid } = useParams();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchWalletHistory = async () => {
      if (!cid) return;
      setLoading(true);
      try {
        const response = await axiosInstance.get(URL.PAYMENT_WALLET_HISTORY, {
          params: { customer_id: cid },
        });
        setRows(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching wallet history:", error);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletHistory();
  }, [cid]);

  const columns = rows.length > 0 ? Object.keys(rows[0]) : [];

  return (
    <Card className="bg-secondary shadow">
      <CardHeader className="bg-white border-0">
        <Row className="align-items-center">
          <Col xs="12">
            <h3 className="mb-0">Credit History</h3>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Table
          className="align-items-center table-flush"
          responsive
          bordered
          hover
        >
          <thead className="thead-light">
            <tr>
              <th>#</th>
              {columns.map((col) => (
                <th key={col}>{humanize(col)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <tr key={row.id ?? idx}>
                  <td>{idx + 1}</td>
                  {columns.map((col) => (
                    <td key={col}>{formatCell(row[col])}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length + 1 || 2}>
                  {loading ? "Loading..." : "No wallet history found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default WalletHistory;
